class Numbers {
  static toNumber(value) {
    if ((typeof value !== 'string')) {
      return 0;
    }
    try {
      return parseFloat(value);
    } catch (e) {
      return 0;
    }
  }

  static addAll(values = []) {
    return values.reduce((acc, current) => acc + current, 0);
  }
}
export default Numbers;
